/**
 *
 * Asynchronously loads the component for CreateSubscriptionPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CreateSubscriptionPage = lazyLoad(
  () => import('./index'),
  module => module.default,
);
